export default class Layer extends Phaser.Group {
  constructor(game, data, inputEnabled = false) {
    super(game);

    this.data = data;
    this.w = 0;

    this.inputEnableChildren = inputEnabled; // enable input
    let x = 0;
    for (let i = 0; i < data.parts.length; i++) {
      const img = this.game.make.image(x, this.game.height, data.parts[i]);
      img.anchor.set(0, 1);
      x += img.width;
      this.w += img.width;
      this.add(img);
    }
  }

  get width() {
    return this.data.width || this.w;
  }

  addSlot(slot) {
    this.add(slot);
  }
}
